import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

export const useInvoices = (userId) => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        if (userId) {
            fetchTransactions();

            // Set up real-time subscription
            const subscription = supabase
                .channel('credit_transactions_changes')
                .on('postgres_changes',
                    {
                        event: '*',
                        schema: 'public',
                        table: 'credit_transactions',
                        filter: `user_id=eq.${userId}`
                    },
                    (payload) => {
                        fetchTransactions(); // Refresh the entire list when any change occurs
                    }
                )
                .subscribe();

            // Cleanup subscription
            return () => {
                subscription.unsubscribe();
            };
        }
    }, [userId]);

    const fetchTransactions = async () => {
        try {
            const { data, error } = await supabase
                .from('credit_transactions')
                .select('*')
                .eq('user_id', userId)
                .eq('transaction_type', 'credit_purchase')
                .order('created_at', { ascending: false });

            if (error) throw error;
            setTransactions(data);
        } catch (err) {
            setError('Failed to load transaction history');
            console.error('Error:', err);
        } finally {
            setLoading(false);
        }
    };

    const fetchRecentTransaction = async (sessionId) => {
        try {
            const { data, error } = await supabase
                .from('credit_transactions')
                .select('*')
                .eq('stripe_payment_id', sessionId)
                .single();

            if (error) throw error;
            return data;
        } catch (err) {
            console.error('Error fetching recent transaction:', err);
            return null;
        }
    };

    return {
        transactions,
        loading,
        error,
        searchTerm,
        setSearchTerm,
        fetchRecentTransaction
    };
};